"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var EmptyStateIcon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  svg {\n    width: 74px;\n    margin-bottom: 1.5rem;\n\n    g {\n      text-align: center;\n      stroke: ", ";\n    }\n  }\n"], ["\n  svg {\n    width: 74px;\n    margin-bottom: 1.5rem;\n\n    g {\n      text-align: center;\n      stroke: ", ";\n    }\n  }\n"])), style_utils_1.getColor("gray", 500));
exports.default = EmptyStateIcon;
var templateObject_1;
//# sourceMappingURL=index.js.map